module.exports = __webpack_public_path__ + "img/pr-8.a21d2788.png";